import { useUser } from '~/stores/user'

export default defineNuxtRouteMiddleware(async (to, _) => {
  const token = useCookie('phiethoc_client')
  const userStore = useUser()

  if (to.path.includes('/login') || to.path.includes('/register')) {
    if (token.value) {
      try {
        await userStore.getUserInfo()
        return navigateTo('/')
      } catch (error) {
        return
      }
    }
    return
  } else if (to.path.includes('/profile')) {
    // Kiểm tra token trước
    if (!token.value) {
      return navigateTo('/login')
    }

    // Chỉ gọi API nếu user chưa có dữ liệu
    if (!userStore.user._id) {
      try {
        await userStore.getUserInfo()
      } catch (error) {
        return navigateTo('/login')
      }
    }
  }
})
